import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../hooks/useLanguage';
import './About.css';
import { UserContext } from '../../context/UserContext';

const About_ru = () => {
  const { user } = useContext(UserContext);
  const lang = useLanguage();

  return (
    <>
      <title>О SeegSoog | Умные инвестиции в недвижимость вне рынка</title>
      <div className="about-container">
        <div className="about-content">
          <h1>О SeegSoog.com</h1>
          <p>
            SeegSoog.com — это торговая площадка, созданная для принятия более умных и быстрых решений в области инвестиций в недвижимость на внерыночном пространстве США. Она объединяет мотивированных продавцов и серьезных инвесторов, стандартизирует
            важные показатели и добавляет анализ на основе ИИ, чтобы каждую сделку можно было оценивать на равных условиях.
          </p>

          <h2>Почему он существует</h2>
          <p>
            SeegSoog возник из простого разочарования: связаться с нужными продавцами было медленно, сравнивать сделки по единым параметрам было сложно, а анализ предложений занимал слишком много времени. Эта платформа была создана, чтобы исправить это,
            централизовав контакты, унифицировав метрики и автоматизировав тяжелый анализ, чтобы фокус оставался на доходности и риске.
          </p>

          <h2>Что он предлагает</h2>
          <ul>
            <li>Централизованные объявления от мотивированных продавцов с прямой и безопасной связью.</li>
            <li>Стандартизированные финансовые показатели для прямого сравнения между рынками и типами недвижимости.</li>
            <li>Отчеты по запросу с помощью ИИ, которые выявляют ключевые показатели, тенденции, чувствительность и предупреждающие знаки.</li>
          </ul>

          <h2>Наш подход</h2>
          <p>
            Прозрачность, честность и скорость лежат в основе каждой функции — от четких входных данных и методологии до оптимизированных процессов обмена сообщениями и принятия решений. Цель проста: помочь инвесторам действовать уверенно, предоставляя
            продавцам профессиональный путь к серьезным покупателям.
          </p>

          <p>
            <Link to={`/${lang}/map`}>Изучите текущие возможности</Link>, узнайте, как работают инструменты, или <Link to={`/${lang}/contact-us`}>свяжитесь с нами</Link>, чтобы поделиться отзывами и повлиять на будущее развитие.
          </p>
          {user.isLoggedIn && user.isAdmin && <p className="admin-message">Вы вошли в систему как администратор.</p>}
        </div>
      </div>
    </>
  );
};

export default About_ru;
